import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { sendContactEmail } from "../../utils/emailService";
import { contactConfig } from "../../config/contact";

function ContactOne() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    institution: "",
    interestedProducts: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [submitMessage, setSubmitMessage] = useState({ type: "", text: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Telefon alanı için özel validasyon (maksimum 11 hane, sadece rakam)
    if (name === "phone") {
      // Sadece rakamları kabul et ve maksimum 11 karakter
      const numericValue = value.replace(/\D/g, "").slice(0, 11);
      setFormData((prev) => ({ ...prev, [name]: numericValue }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage({ type: "", text: "" });

    try {
      const result = await sendContactEmail(formData);
      if (result.success) {
        setIsSuccess(true);
        // setSubmitMessage({ type: "success", text: t("contact.messageSent") }); // Keeping this purely visual on button now, or should I keep both? User said "instead of button".
        // Clearing form data
        setFormData({
          name: "",
          email: "",
          phone: "",
          institution: "",
          interestedProducts: "",
          message: "",
        });
        
        // Reset success state after 2 seconds
        setTimeout(() => {
            setIsSuccess(false);
        }, 2000);

      } else {
        setSubmitMessage({ type: "error", text: result.message });
      }
    } catch (error) {
      setSubmitMessage({ type: "error", text: t("contact.errorOccurred") });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="contact-area3 bg-top-center overflow-hidden"
      style={{
        position: "relative",
        marginBottom: "20px",
      }}
    >
      {/* Background with opacity */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          zIndex: 0,
          backgroundImage: "url(/assets/img/yurt-fotograf/dis-cephe/33.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.3,
          pointerEvents: "none",
        }}
        aria-hidden="true"
      ></div>
      {/* Foreground content */}
      <div className="container" style={{ position: "relative", zIndex: 1 }}>
        <div className="row gy-4 justify-content-between align-items-center">
          <div className="col-lg-5">
            <div className="pt-80 p-lg-0">
              <div className="title-area pe-xl-5">
                <span className="sub-title text-white">
                  {t("contact.getInTouchTitle")}
                </span>
                <h2 className="sec-title text-white">
                  {t("contact.onlineRegistration")}
                </h2>
                <p className="contact-text text-white">
                  {t("contact.sayHelloDesc")}
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="contact-form-area">
              <form
                onSubmit={handleSubmit}
                className="contact-form2 ajax-contact"
              >
                <div className="row">
                  <div className="form-group col-12">
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      id="name3"
                      placeholder={t("contact.firstName") + " *"}
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                    <img src="/assets/img/icon/user.svg" alt="" />
                  </div>
                  <div className="form-group col-12 col-md-6">
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      id="email3"
                      placeholder={t("contact.yourMail")}
                      value={formData.email}
                      onChange={handleChange}
                    />
                    <img src="/assets/img/icon/mail.svg" alt="" />
                  </div>
                  <div className="form-group col-12 col-md-6">
                    <input
                      type="tel"
                      className="form-control"
                      name="phone"
                      id="phone3"
                      placeholder={t("contact.yourPhone") + " *"}
                      value={formData.phone}
                      onChange={handleChange}
                      maxLength={11}
                      pattern="[0-9]{0,11}"
                      required
                    />
                    <img src="/assets/img/icon/call.svg" alt="" />
                  </div>
                  <div className="form-group col-12">
                    <input
                      type="text"
                      className="form-control"
                      name="institution"
                      id="institution3"
                      placeholder={t("contact.institution")}
                      value={formData.institution}
                      onChange={handleChange}
                    />
                    <img src="/assets/img/icon/user.svg" alt="" />
                  </div>
                  <div className="form-group col-12">
                    <input
                      type="text"
                      className="form-control"
                      name="interestedProducts"
                      id="interestedProducts3"
                      placeholder={t("contact.interestedProducts")}
                      value={formData.interestedProducts}
                      onChange={handleChange}
                    />
                    <img src="/assets/img/icon/chat.svg" alt="" />
                  </div>
                  <div className="form-group col-12">
                    <textarea
                      name="message"
                      id="message"
                      cols={30}
                      rows={3}
                      className="form-control"
                      placeholder={t("contact.yourMessage")}
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                    <img src="/assets/img/icon/chat.svg" alt="" />
                  </div>
                </div>
                {submitMessage.text && (
                  <p
                    className={`form-messages mb-0 mt-3 ${
                      submitMessage.type === "success"
                        ? "text-success"
                        : "text-danger"
                    }`}
                  >
                    {submitMessage.text}
                  </p>
                )}
              </form>
              <div className="form-btn-wrapp">
                <div className="form-btn">
                   <button
                    type="submit"
                    onClick={handleSubmit}
                    className={`th-btn ${isSuccess ? 'success-btn' : 'white-btn'}`}
                    disabled={isSubmitting || isSuccess}
                  >
                    {isSubmitting
                      ? t("contact.sending")
                      : isSuccess
                      ? t("contact.mailSent")
                      : t("contact.sendMessage")}
                    {!isSuccess && <img src="/assets/img/icon/plane3.svg" alt="" />}
                    {isSuccess && <i className="fas fa-check ms-2"></i>}
                  </button>
                </div>
                <div className="contact-info">
                  <p className="contact-info_link">
                    <Link
                      to={`tel:${contactConfig.phone.primary.replace(
                        /\s/g,
                        ""
                      )}`}
                    >
                      {contactConfig.phone.primary}
                    </Link>
                  </p>
                  <div className="contact-info_icon">
                    <Link
                      to={`tel:${contactConfig.phone.primary.replace(
                        /\s/g,
                        ""
                      )}`}
                    >
                      <img src="/assets/img/icon/call.svg" alt="" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactOne;
